// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qebS","question":"styles_question__ppr3t","description":"styles_description__3Un1Z"};